export const ENGLISH = 0;
export const GUJARATI = 1;
export const HINDI = 2;
export const SPANISH = 3;
export const FRENCH = 4;
export const GERMAN = 5;
export const RUSSIAN = 6;
export const MANDARIN = 7;
export const PORTUGUESE = 8;
export const KOREAN = 9;
export const KANNADA = 10;
export const TELUGU = 11;
export const TAMIL = 12;
export const BENGALI = 13;
export const MARATHI = 14;
export const ARABIC = 15;
export const MALAYALAM = 16;
export const ITALIAN = 17;
export const DUTCH = 18;
export const POLISH = 19;
export const TURKISH = 20;
export const GREEK = 21;
export const JAPANESE = 22;
export const THAI = 23;
export const VIETNAMESE = 24;
export const INDONESIAN = 25;
export const MALAY = 26;
export const BURMESE = 27;
export const PERSIAN = 28;
export const HEBREW = 29;
export const SWAHILI = 30;
export const HAUSA = 31;
export const URDU = 32;
export const PUNJABI = 33;
export const SINHALA = 34;
export const NEPALI = 35;
export const TAGALOG = 36;
export const KHMER = 37;
export const LAO = 38;
export const SWEDISH = 39;
export const NORWEGIAN = 40;
export const DANISH = 41;
export const FINNISH = 42;
export const HUNGARIAN = 43;
export const CZECH = 44;
export const ROMANIAN = 45;
export const YORUBA = 46;
export const IGBO = 47;
export const AMHARIC = 48;
export const SOMALI = 49;
export const XHOSA = 50;
export const ZULU = 51;
export const QUECHUA = 52;
export const CATALAN = 53;
export const UZBEK = 54;
export const KAZAKH = 55;
export const MONGOLIAN = 56;
export const TIBETAN = 57;
export const ARMENIAN = 58;
export const GEORGIAN = 59;
export const SLOVENIAN = 60;

export const LanguageList = Object.freeze({
    ENGLISH: 0,
    GUJARATI: 1,
    HINDI: 2,
    SPANISH: 3,
    FRENCH: 4,
    GERMAN: 5,
    RUSSIAN: 6,
    MANDARIN: 7,
    PORTUGUESE: 8,
    KOREAN: 9,
    KANNADA: 10,
    TELUGU: 11,
    TAMIL: 12,
    BENGALI: 13,
    MARATHI: 14,
    ARABIC: 15,
    MALAYALAM: 16,
    ITALIAN: 17,
    DUTCH: 18,
    POLISH: 19,
    TURKISH: 20,
    GREEK: 21,
    JAPANESE: 22,
    THAI: 23,
    VIETNAMESE: 24,
    INDONESIAN: 25,
    MALAY: 26,
    BURMESE: 27,
    PERSIAN: 28,
    HEBREW: 29,
    SWAHILI: 30,
    HAUSA: 31,
    URDU: 32,
    PUNJABI: 33,
    SINHALA: 34,
    NEPALI: 35,
    TAGALOG: 36,
    KHMER: 37,
    LAO: 38,
    SWEDISH: 39,
    NORWEGIAN: 40,
    DANISH: 41,
    FINNISH: 42,
    HUNGARIAN: 43,
    CZECH: 44,
    ROMANIAN: 45,
    YORUBA: 46,
    IGBO: 47,
    AMHARIC: 48,
    SOMALI: 49,
    XHOSA: 50,
    ZULU: 51,
    QUECHUA: 52,
    CATALAN: 53,
    UZBEK: 54,
    KAZAKH: 55,
    MONGOLIAN: 56,
    TIBETAN: 57,
    ARMENIAN: 58,
    GEORGIAN: 59,
    SLOVENIAN: 60,
});

// Language mapping object for easy lookup
export const LANGUAGE_MAP = {
    guj: 'Gujarati',
    hin: 'Hindi',
    eng: 'English',
    spa: 'Spanish',
    fre: 'French',
    ger: 'German',
    rus: 'Russian',
    chi: 'Mandarin',
    por: 'Portuguese',
    kor: 'Korean',
    kan: 'Kannada',
    tel: 'Telugu',
    tam: 'Tamil',
    ben: 'Bengali',
    mar: 'Marathi',
    ara: 'Arabic',
    mal: 'Malayalam',
    ita: 'Italian',
    dut: 'Dutch',
    pol: 'Polish',
    tur: 'Turkish',
    gre: 'Greek',
    jpn: 'Japanese',
    tha: 'Thai',
    vie: 'Vietnamese',
    ind: 'Indonesian',
    may: 'Malay',
    bur: 'Burmese',
    per: 'Persian',
    heb: 'Hebrew',
    swa: 'Swahili',
    hau: 'Hausa',
    urd: 'Urdu',
    pun: 'Punjabi',
    sin: 'Sinhala',
    nep: 'Nepali',
    tag: 'Tagalog',
    khm: 'Khmer',
    lao: 'Lao',
    swe: 'Swedish',
    nor: 'Norwegian',
    dan: 'Danish',
    fin: 'Finnish',
    hun: 'Hungarian',
    cze: 'Czech',
    rum: 'Romanian',
    yor: 'Yoruba',
    ibo: 'Igbo',
    amh: 'Amharic',
    som: 'Somali',
    xho: 'Xhosa',
    zul: 'Zulu',
    que: 'Quechua',
    cat: 'Catalan',
    uzb: 'Uzbek',
    kaz: 'Kazakh',
    mon: 'Mongolian',
    tib: 'Tibetan',
    arm: 'Armenian',
    geo: 'Georgian',
    slv: 'Slovenian',
};
